import React from 'react';
import './testimonial.css';


function Testimonial({Icon, info, imageUrl, name, title}) {
  return (
    
     
      <div className='testimonialsec'>
          <div className='ratings'>
            <Icon fontSize='small' style={{ color: 'orange' }} />
            <Icon fontSize='small'style={{ color: 'orange' }} />
            <Icon fontSize='small' style={{ color: 'orange' }}/>
            <Icon fontSize='small' style={{ color: 'orange' }}/>
            <Icon fontSize='small' style={{ color: 'orange' }}/>
          </div>
          <p>{info}</p>
          <div className='lowersection'>
            <img className='imge' src={imageUrl} alt={title}/>
            <div className='nameandt'>
              <h4>{name}</h4>
              <p>{title}</p>
            </div>
          </div>
          
   
    </div>
   
  )
}

export default Testimonial